import { TranslocoService } from '@ngneat/transloco';
import { Patient } from 'src/app/core/api/patient.service';

const isBlank = (val: any): boolean => typeof val !== 'string' || !val.trim();

export interface RequiredEnrollmentField {
  label: string;
  isMissing: (patient: Partial<Patient>) => boolean;
}

const REQUIRED_PATIENT_APP_ENROLLMENT_FIELDS: RequiredEnrollmentField[] = [
  { label: 'First Name', isMissing: patient => isBlank(patient.firstName) },
  { label: 'Last Name', isMissing: patient => isBlank(patient.lastName) },
  { label: 'Email', isMissing: patient => isBlank(patient.email) }
];

const ALL_ENROLLMENT_FIELD_LABELS = REQUIRED_PATIENT_APP_ENROLLMENT_FIELDS.map(
  field => field.label
);
const NO_MISSING_ENROLLMENT: EnrollmentStatus = Object.freeze({
  isMissingFields: false,
  message: ''
});

export interface EnrollmentStatus {
  isMissingFields: boolean;
  message: string;
}

export function hasMissingEnrollmentFields(
  patient?: Partial<Patient> | null,
  translocoService?: TranslocoService
): EnrollmentStatus {
  if (patient && patient.patientAppId) {
    return NO_MISSING_ENROLLMENT;
  }

  const missingLabels = !patient
    ? ALL_ENROLLMENT_FIELD_LABELS
    : REQUIRED_PATIENT_APP_ENROLLMENT_FIELDS.filter(field => field.isMissing(patient)).map(
        field => field.label
      );

  if (missingLabels.length === 0) {
    return NO_MISSING_ENROLLMENT;
  }

  const translatedFields = missingLabels
    .map(label => (translocoService ? translocoService.translate(label) : label))
    .join(', ');

  const translationKey =
    missingLabels.length === 1 ? 'missingEnrollmentField' : 'missingEnrollmentFields';

  const message = translocoService
    ? translocoService.translate(translationKey, { fields: translatedFields })
    : missingLabels.length === 1
    ? `Please fill out the following field in the Patient Profile in order to Enroll in the Patient App: ${translatedFields}`
    : `Please fill out the following fields in the Patient Profile in order to Enroll in the Patient App: ${translatedFields}`;

  return { isMissingFields: true, message };
}
